import React from 'react';

import { ACCOUNT_USER_DETAIL_CS_INQUIRY_HISTORY_LIST_FILTER_OPTION_MODEL } from '../../../../../store/modules/account/user/models';
import { CS_INQUIRY_LIST_SORT_OPTION_MODEL } from '../../../../../store/modules/cs/inquiry/models';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { CS_INQUIRY_LIST_TABLE_EMPTY_TEXT } from '../../../../../constants/service/app/csInquiryConstants';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import columns from './columns';
import { useAccountUserCsInquiryDetail } from './hooks';

const AccountUserDetailCsInquiryInfo = (props) => {
  const { userId, isActive } = props;

  const { csInquiryList, getList, downloadDetailCsInquiryListExcel, pagination, sortOption, filterOption } =
    useAccountUserCsInquiryDetail({ userId, isActive });
  const { list, totalCnt } = csInquiryList;

  return (
    <div className="account-user-detail-content">
      <div className="account-user-detail-section">
        <div className="title">1:1 문의 리스트</div>

        <div className="account-user-detail-section-content">
          <TableWithSummary
            className="account-user-detail-section-list"
            data={list}
            totalCnt={totalCnt}
            initialOption={{
              filterOption: ACCOUNT_USER_DETAIL_CS_INQUIRY_HISTORY_LIST_FILTER_OPTION_MODEL,
              sortOption: CS_INQUIRY_LIST_SORT_OPTION_MODEL,
              pagination: LIST_PAGINATION_MODEL,
            }}
            isStriped={true}
            emptyText={CS_INQUIRY_LIST_TABLE_EMPTY_TEXT}
            showPagination
            filterOption={filterOption}
            sortOption={sortOption}
            pagination={pagination}
            getList={getList}
            getExcelDownload={downloadDetailCsInquiryListExcel}
            columns={(utils) =>
              columns({
                ...utils,
              })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default AccountUserDetailCsInquiryInfo;
